import { Routes } from '@angular/router';

import { ContactComponent } from './contact.component';


export const contactRoute: Routes = [
  {
    path: 'contact',
    component: ContactComponent,
    data: {
        pageTitle: 'cadensApp.contact.home.title'
    }
  }
];




// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/contact/contact.route.ts